import { api } from '../../http';
import { TaskStatus } from '../../types/interfaces';
import { ObjectForSelection } from '../../types/interfaces/ObjectForSelection';

import Api from './api';
import IObjectForSelection from './interfaces/objectForSelection';
import ITaskStatusesApi from './interfaces/taskStatusesApi';

class TaskStatusesApi
  extends Api<TaskStatus>
  implements ITaskStatusesApi, IObjectForSelection
{
  constructor(abortController: AbortController) {
    super('taskStatus/', abortController);
  }
  async getForSelection() {
    const apiCallResult = await api.get<ObjectForSelection[]>(
      'taskStatus/getForSelection',
      { signal: this._abortController.signal }
    );
    return apiCallResult?.data;
  }
}

export default TaskStatusesApi;
